import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>அபரம் முன்னுரை</h1>
  <mat-accordion>
    <mat-expansion-panel>
              <mat-expansion-panel-header>முன்னுரை
          </mat-expansion-panel-header>
     <div class="div3">
      பலர் அசுப காரியங்களைப் பற்றி பேசுவது, தெரிந்து கொள்வதைக் கூட தவறாக நினைக்கிறார்கள். தினமும் அபர காரியங்களில் ஈடுபடும் வாத்யார்கள், பிணம் சுமப்பவர்கள், பிண ஊர்தி ஓட்டுகிறவர்கள் போன்றோர்கள் இல்லத்தில் எந்த பாதிப்பும் இல்லாமல் நன்றாகவே இருக்கிறார்கள். அதனால் ஒருவர் இதுபற்றி அறியாமலே இருந்து இதிலிருந்து தப்பித்துக்கொள்ள முடியாது என்பதைத் தெரிந்து கொள்ளவேண்டும். 
     </div>
            
    
    </mat-expansion-panel >
    <mat-expansion-panel>
      <mat-expansion-panel-header>பொது விஷயங்கள்
    </mat-expansion-panel-header>
          <div class="div3">
            <div style="line-height:20px; color:Blue; text-align:justify">
            மரணம் சம்பந்தமான வைதீக காரியங்களை அபர காரியம் என்று சொல்வது மரபு.
            தஹனம் முதல் சுபஸ்வீகாரம் வரையிலான விஷயங்கள் கீழே சிறு குறிப்புகளாக
            வழங்கப்பட்டுள்ளன. மேன்மேலும் விபரங்கள் மந்திரங்கள், ஸம்ப்ரதாயங்கள்
            போன்றவை தனித் தனிப் பக்கங்கங்களில் மிகவும் விரிவாக வழங்கப்பட்டுள்ளன.
            உங்கள் சந்தேஹம் எதுவானாலும் தயங்காமல் ஈமெயில் மூலம் கேட்கலாம்.
            </div>
            <h6>மரணத்திற்குப்பின் செய்யவேண்டிய க்ரியைகள்</h6>
            <div class="svk2">
            <span class="title3">ஒருவர் இறந்தபின் நடத்தப்படவேண்டிய காரியங்கள்:</span><br />
            1. தஹனம்&nbsp;
            <br />
            2. சஞ்சயனம்
            <br />
            3. நக்னச்ராத்தம்
            <br />
            4. பாஷாண ஸ்தாபனம்
            <br />
            5. நித்யவிதி
            <br />
            6. ஏகோத்ர வ்ருத்தி ச்ராத்தம்
            <br />
            7. நவச்ராத்தம்
            <br />
            8. பங்காளி தர்பணம்
            <br />
            9. ப்ரபூதபலி
            <br />
            10. பாஷாண உத்தாபனம்
        <br />
            11. சாந்தி, ஆனந்த ஹோமம் 
            <br />
            12. வ்ருஷப உத்ஸர்ஜனம்
            <br />
            13. ஏகாதச ப்ராஹ்மண  போஜனம்
            <br />
            14. ஆத்ய மாஸிகம்
            <br />
            15. ஆவ்ருதாத்ய மாஸிகம்
            <br />
            16. ஷோடசம்
            <br />
            17. ஸபிண்டீகரணம்
            <br />
            18. ஆத்ய ஸோதகும்பம்
            <br />
            19. இயல் ஸேவாகாலம்
            <br />
            20. சுப ஸ்வீகாரம்
            <br />
            <span style="color: red">
                    நக்ன ச்ராத்தம் </span>: இறந்தவருக்கு ஏற்படும் ஐந்துவிதமான பாதிப்புகளிலிருந்து விமோசனம்
                    ஏற்பட செய்யப்படுவது.<br />
             
             
             
                              <span style="color: red">பாஷாண ஸ்தாபனம்</span> : தடாகதீரம், க்ருஹத்வாரம் என இரு இடங்களில் சிறு குண்டம் அமைத்து ஆன்மாவை
                    கல்லில் ஆவாஹனம் செய்வது.<br />
             
             
             
                              <span style="color: red">நித்யவிதி</span> : ஆவாஹனம் செய்யப்பட்ட ஆன்மாவிற்கு தினமும் வாஸ உதகம், தில உதகம், பிண்டங்கள்
                    ஸமர்ப்பிப்பது.<br />
             
             
              
                              <span style="color: red">
                    ஏகோத்திர வ்ருத்தி ச்ராத்தம்</span> :- பத்தாம் நாள் வரை தினமும் பண்ணவேண்டிய ச்ராத்தம்.<br />
             
             
             
                              <span style="color: red">
                    நவ ச்ராத்தம்</span> :- பதினொன்றாம் நாள் வரை 1, 3, 5, 7, 9, 11 ஆகிய ஒற்றைப்படை நாட்களில்
                    பண்ண வேண்டிய ச்ராத்தம்.<br />
             
             
              
                    10ம்நாள் <span style="color: red">பங்காளி தர்ப்பணம்</span> : பத்துநாள் பங்காளிகள் காரியம் நடக்கும் இடத்திற்கு வந்து
                    10 நாளைக்கும் சேர்த்து தர்ப்பிக்கவேண்டும்.<br />
             
             
            
                              <span style="color: red">க்ஷவரம் </span>:- இறந்தவரைவிட வயதில் சிறிய பங்காளிகள் க்ஷவரம் பண்ணிக்கொண்டு தர்ப்பிக்கவேண்டும்.&nbsp;
                    கர்தாக்கள் பிறகு...<br />
             
             
             
                              <span style="color: red">ப்ரபூதபலி</span>: ஒரு படி சாதம், 5அடை, உருண்டை, அகத்திக்கீரை, .... இவைகளை படைத்து உபசரிப்பது.<br />
             
             
              
                              <span style="color: red">
                    சுமங்கலி விஷயம்</span> :-&nbsp; இறந்தவர் சுமங்கலியானால் பலியில் சில விசேஷங்கள்.<br />
             
             
              
                              <span style="color: red">புடவை போடுவது</span>:- கணவருக்கு நடக்கும் பத்தாம் நாள் க்ருத்யத்தில் உயிருடன் இருக்கும்
                    மனைவிக்கு புடவை போடுவபற்றி<br />
             
             
              
                              <span style="color: red">
                    பாஷணாண உத்தாபனம்</span> : ஆன்மாவை யதாஸ்தானம் பண்ணி கல்லை எடுப்பது.<br />
             
             
              
                              <span style="color: red">
                    பலியை ஜலத்தில் சேர்ப்பது, கர்த்தாக்கள் க்ஷவரம்</span> :-<br />
             
             
            
                              <span style="color: red">
                    சாந்தி, ஆனந்த ஹோமம்</span> :-<br />
             
             
             
                    சாரு ஸம்பாவனை, அப்பம் பொரி ஓதியிடுதல்:<br />
             
             
              
                              <span style="color: red">
                    11ம் நாள்</span> :- புண்யாஹம், நவச்ராத்தம், வ்ருஷப உத்ஸர்ஜனம், ஆத்ய மாஸிகம், ஆவ்ருத்தாத்ய
                    மாஸிகம் இத்யாதிகள்<br />
             
             
                              <span style="color: red">
                    12ம் நாள்</span> : புண்யாஹம், ஒளபாஸனம், சோடசம், ஸபிண்டீகரணம், தானங்கள், சோதகும்பம்.<br />
             
          
                              <span style="color: red">
                    ஸேவா காலம்</span> : வேத, ப்ரபந்த பாராயணங்கள்<br />
             
             
            
                    13ம் நாள் : ஸேவை, சாத்துமுறை, உபந்யாஸம்,
                              <br />
                              <span style="color: red">சுப ஸ்வீகாரம்</span><br />
             
             
            
                              <span style="color: red">
                    ஊனங்கள், மாஸ்யங்கள்</span> : நாட்கள் குறிக்க உதவி<br />
             
             
              
                              <span style="color: red">
                    புண்யகால தர்ப்பணங்கள்</span>: பண்ணவேண்டியவை<br />
             
             
              
                              <span style="color: red">வருஷாப்தீகம்</span>: ஆப்தீக வழிமுறைகள்&nbsp;<br />
             
             
             
                              <span style="color: red">
               வருஷாப்தீக ததியாராதனம்</span> : பற்றிய விளக்கம்<br />
             
            </div>
            <h6>தஹன தின க்ரியைகள்</h6>
            <div class="svk2">
            பலர் அசுப காரியங்களைப் பற்றி பேசுவது, தெரிந்து கொள்வதைக் கூட தவறாக நினைக்கிறார்கள்.
                    தினமும் அபர காரியங்களில் ஈடுபடும் வாத்யார்கள், பிணம் சுமப்பவர்கள், பிண ஊர்தி ஓட்டுகிறவர்கள்
                    போன்றோர்கள் இல்லத்தில் எந்த பாதிப்பும் இல்லாமல் நன்றாகவே இருக்கிறார்கள். அதனால்
                    &nbsp;ஒருவர் இதுபற்றி&nbsp; அறியாமலே இருந்து இதிலிருந்து தப்பித்துக்கொள்ள முடியாது
                    என்பதைத் தெரிந்து கொள்ளவேண்டும்.
                                     <span style="color: #ff0000">தஹனம்</span> :- இறந்தவருக்குச் செய்யப்படும் முதல் நாள் க்ரியைகள். மரணத்தால் ஆன்மாவை விட்டுப்
                    பிரிந்த சரீரத்திற்காகச் செய்யப்படும் கர்மா.<br />
                                                    
                                                    
                   <br />                                     
               
                                                    
                                               
            </div>
            <h6>ஸஞ்சயனம்</h6>
            <div class="svk2">
            <span style="color: #ff0000">சஞ்சயனம் </span>: சஞ்சயனமாவது தஹனத்தின் பிறகு எஞ்சிய சரீரத்தின் 
            எலும்பு முதலிய பாகங்களை முறைப்படி இறுதி செய்வது.<br />
                                                <ul>
                                                    <li>அக்நி நஷ்ட ப்ராயச்சித்தம்</li>
                                                    <li>குக்குட ச்ருகாளாதி ஸ்பர்ச ப்ராயச்சித்தம்</li>
                                                    <li>அஸ்தி ஸஞ்சயனம்</li>
                                                    <li>அஸ்தி நிக்ஷேபணம்</li>
                                                </ul>
            </div>
            <h6>நித்யவிதி</h6>
            <div class="svk2">
            கல் ஊன்றிய நாள் முதல் தினமும் வாஸோதகம், திலோதகம்
            பிண்ட ப்ரதானம், ஏகோத்ர வ்ருத்தி ச்ராத்தம், நவச்ராத்தம்
            போன்றவை கர்த்தாக்களால் செய்யப்படவேண்டும்.
                                           
            </div>
            <h6>10ம்நாள் க்ரியைகள்</h6>
            <div class="svk2">
            
               
                10ம்நாள் <span style="color: red">பங்காளி தர்ப்பணம்</span> : பத்துநாள் பங்காளிகள்
                காரியம் நடக்கும் இடத்திற்கு வந்து 10 நாளைக்கும் சேர்த்து தர்ப்பிக்கவேண்டும்.<br />
                                                
                                                
                                                    
                
                <span style="color: red">க்ஷவரம் </span>:- இறந்தவரைவிட வயதில் சிறிய பங்காளிகள் க்ஷவரம்
                பண்ணிக்கொண்டு தர்ப்பிக்கவேண்டும்.&nbsp; கர்தாக்கள் பிறகு...<br />
                                                
                                                
                                                    
               
                <span style="color: red">ப்ரபூதபலி</span>: ஒரு படி சாதம், 5அடை, உருண்டை, அகத்திக்கீரை,
                .... இவைகளை படைத்து உபசரிப்பது.<br />
                                                
                                                
                                                    
               
                <span style="color: red">சுமங்கலி விஷயம்</span> :-&nbsp; இறந்தவர் சுமங்கலியானால்
                பலியில் சில விசேஷங்கள்.<br />
                                                
                                                
                                                    
                
                <span style="color: red">புடவை போடுவது</span>:- கணவருக்கு நடக்கும் பத்தாம் நாள்
                க்ருத்யத்தில் உயிருடன் இருக்கும் மனைவிக்கு புடவை போடுவபற்றி<br />
                                                
                                                
                                                    
               
                <span style="color: red">பாஷணாண உத்தாபனம்</span> : ஆன்மாவை யதாஸ்தானம் பண்ணி கல்லை
                எடுப்பது.<br />
                                                
                                                
                                                    
               
                <span style="color: red">பலியை ஜலத்தில் சேர்ப்பது, கர்த்தாக்கள் க்ஷவரம்</span> :-<br />
                                                
                                                
                                                    
               
                <span style="color: red">சாந்தி, ஆனந்த ஹோமம்</span> :-<br />
                                                
                                                
                                                    
               
                சாரு ஸம்பாவனை, அப்பம் பொரி ஓதியிடுதல்:<br />
            </div>
            <h6>11ம் நாள்</h6>
            <div class="svk2">
            <span style="color: red">11ம் நாள்</span> :- புண்யாஹம், நவச்ராத்தம், வ்ருஷப உத்ஸர்ஜனம்,
                                                        ஆத்ய மாஸிகம், ஆவ்ருத்தாத்ய மாஸிகம் இத்யாதிகள்<br />
            </div>
            <h6>12ம் நாள்</h6>
            <div class="svk2">
            <br />
                                                        <ul>
                                                            <li>புண்யாஹம், </li>
                                                            <li>ஒளபாஸனம், </li>
                                                            <li>சோடசம், </li>
                                                            <li>ஸபிண்டீகரணம், </li>
                                                            <li>தானங்கள், </li>
                                                            <li>சோதகும்பம்.</li>
                                                        </ul>
                                                    <br />
            </div>
            <h6>ஸேவா காலம்</h6>
            <div class="svk2">
            <span style="color: red">ஸேவா காலம்</span> : சிலர் முதல் நாளே (12ம் நாளே) வேத, ப்ரபந்த
                                                        பாராயணங்கள் தொடங்கி ஸேவிப்பர்.<br />
                     <ul>
                                                    <li>ஸேவாகாலம் தொடக்கம் அல்லது தொடர்ச்சி</li>
                                                    <li>இயல் - ஆழ்வார்கோஷ்டி</li>
                                                    <li>பால் தொடுதல், பிடி சுற்றுதல்</li>
                                                    <li>சாத்துமுறை</li>
                                                    <li>சர்மஸ்லோக வ்யாக்யானம், உபந்யாஸம்</li>
                                                    <li>சுப ஸ்வீகாரம்</li>
                                                    <li>அக்ஷதை ஆசீர்வாதம்</li>
                                                    <li>ஹாரத்தி</li>
                                                </ul>
            </div>
            <h6>சர்மஸ்லோக வ்யாக்யானம் - உபந்யாஸம்</h6>
            <div class="svk2">
    
            </div>
            <h6>சுபம்</h6>
            <div class="svk2">
            மங்களப் பொருட்களான சந்தனம், புஷ்பம், குங்குமம் இவற்றைத் தரித்துக்கொள்ளுதல்.
            </div>
          </div>
            </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>கர்மாக்கள் விபரம்
 </mat-expansion-panel-header>
<div class="div3">

<span class="hint">தஹனம் :-</span> இறந்தவருக்குச் செய்யப்படும் முதல் நாள் க்ரியைகள். 
மரணத்தால் ஆன்மாவை விட்டுப் பிரிந்த சரீரத்திற்காகச் செய்யப்படும் கர்மா. 
<ul>
<li>ஜீவ ப்ராயச்சித்தம்</li>
   <li>சாமான்களும் - ஏற்பாடுகளும்</li>
   <li>ஸ்ரீசூர்ண பரிபாலனம்</li>
   <li> அக்நி நிர்ணயம், ப்ரேதாக்நி ஸந்தானம் உத்தபனாக்னி, கபாலாக்னி ஸந்தானம்</li> 
   <li>பைத்ருமேதிக, ப்ராயச்சித்தாதி ஹோமங்கள்</li>
   <li>ஸ்மஸானத்தில் க்ரியைகள்</li>
   <li>தஹனத்தின் பின் செய்ய வேண்டியவை</li> 
   <li>சஞ்சயன சாமான்கள், ஏற்பாடுகள்</li>
</ul>
<hr class="orange"><span class="hint">சஞ்சயனம் :</span> தஹனத்தின் பிறகு எஞ்சிய சரீரத்தின் 
பாகங்களை முறைப்படி இறுதி செய்வது. 
அக்நி நஷ்ட ப்ராயச்சித்தம் குக்குட ச்ருகாளாதி ஸ்பர்ச ப்ராயச்சித்தம்,
 அஸ்தி ஸஞ்சயனம், அஸ்தி நிக்ஷேபணம் 
 <hr class="orange"><span class="hint">நக்ன ச்ராத்தம் :</span> இறந்தவருக்கு ஏற்படும் ஐந்துவிதமான 
 பாதிப்புகளிலிருந்து விமோசனம் ஏற்பட செய்யப்படுவது. 
 <hr class="orange"><span class="hint">பாஷாண ஸ்தாபனம் :</span> தடாகதீரம், 
 க்ருஹத்வாரம் என இரு இடங்களில் சிறு குண்டம் அமைத்து ஆன்மாவை கல்லில் 
 ஆவாஹனம் செய்வது. நித்யவிதி : ஆவாஹனம் செய்யப்பட்ட ஆன்மாவிற்கு 
 தினமும் வாஸ உதகம், தில உதகம், பிண்டங்கள் ஸமர்ப்பிப்பது. 
 <hr class="orange"><span class="hint">ஏகோத்திர வ்ருத்தி ச்ராத்தம் :-</span> 
 பத்தாம் நாள் வரை தினமும் பண்ணவேண்டிய ச்ராத்தம். 
 <hr class="orange"><span class="hint">நவ ச்ராத்தம் :-</span> பதினொன்றாம் நாள் வரை 
 1, 3, 5, 7, 9, 11 ஆகிய ஒற்றைப்படை நாட்களில் பண்ண வேண்டிய ச்ராத்தம். 
 <hr class="orange"><span class="hint">10ம்நாள் பங்காளி தர்ப்பணம் :</span>
  பத்துநாள் பங்காளிகள் காரியம் நடக்கும் இடத்திற்கு வந்து 10 நாளைக்கும் சேர்த்து 
  தர்ப்பிக்கவேண்டும். 
  <hr class="orange"><span class="hint">க்ஷவரம் :-</span> இறந்தவரைவிட வயதில் 
  சிறிய பங்காளிகள் க்ஷவரம் பண்ணிக்கொண்டு தர்ப்பிக்கவேண்டும். கர்தாக்கள் பிறகு... 
  <hr class="orange"><span class="hint">ப்ரபூதபலி:</span> ஒரு படி சாதம், 5அடை, உருண்டை, 
  அகத்திக்கீரை, .... இவைகளை படைத்து உபசரிப்பது. 
  <hr class="orange"><span class="hint">சுமங்கலி விஷயம் :-</span> இறந்தவர் சுமங்கலியானால் 
  பலியில் சில விசேஷங்கள். <hr class="orange"><span class="hint">புடவை போடுவது:-</span> 
  கணவருக்கு நடக்கும் பத்தாம் நாள் க்ருத்யத்தில் உயிருடன் இருக்கும் மனைவிக்கு புடவை 
  போடுவபற்றி 
  <hr class="orange"><span class="hint">பாஷணாண உத்தாபனம் :</span> 
  ஆன்மாவை யதாஸ்தானம் பண்ணி கல்லை எடுப்பது. பலியை ஜலத்தில் சேர்ப்பது, 
  <hr class="orange"><span class="hint">கர்த்தாக்கள் க்ஷவரம் :-</span> 
  <hr class="orange"><span class="hint">சாந்தி, ஆனந்த ஹோமம் :-</span> 
  சாரு ஸம்பாவனை, அப்பம் பொரி ஓதியிடுதல்: 
  <hr class="orange"><span class="hint">11ம் நாள் :-</span> புண்யாஹம், நவச்ராத்தம், 
  வ்ருஷப உத்ஸர்ஜனம், ஆத்ய மாஸிகம், ஆவ்ருத்தாத்ய மாஸிகம் இத்யாதிகள் 
  <hr class="orange"><span class="hint">12ம் நாள் :</span> புண்யாஹம், ஒளபாஸனம், 
  சோடசம், ஸபிண்டீகரணம், தானங்கள், சோதகும்பம். 
  <hr class="orange"><span class="hint">ஸேவா காலம் :</span> வேத, ப்ரபந்த பாராயணங்கள் 
  <hr class="orange"><span class="hint">13ம் நாள் :</span> ஸேவை, சாத்துமுறை, 
  உபந்யாஸம், சுப ஸ்வீகாரம் 
  <hr class="orange"><span class="hint">ஊனங்கள், மாஸ்யங்கள் :</span> நாட்கள் குறிக்க 
  உதவி 
  <hr class="orange"><span class="hint">புண்யகால தர்ப்பணங்கள்:</span> பண்ணவேண்டியவை 
  <hr class="orange"><span class="hint">வருஷாப்தீகம்:</span> ஆப்தீக வழிமுறைகள் 
  வருஷாப்தீக 
  <hr class="orange"><span class="hint">ததியாராதனம் :</span> பற்றிய விளக்கம் 
</div> 

</mat-expansion-panel >

        
        
        
    </mat-accordion>`;

const AparamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="வாயில்-முன்னுரை - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default AparamPage;
